// extracted by mini-css-extract-plugin
module.exports = {"homepageGridWrapper":"_1oS8weDdOXZkeXa5IevrHa","newsletterBlock":"_3BsuLhdQbJDJUOzNVa9WzR"};